import { useEffect, useState } from 'react';
import useFetchGraphQL from '../../hooks/useFetchGraphQL';

const resourceIds = ["D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10", "C1", "C2"];

const globalLoadingTime = 1000; // 1 sec

const CheckTimeSlots = ({ currentBooking, onOutputChange, refreshTimeSlots, setLoading }) => {
  const [existingBookings, setExistingBookings] = useState([]);
  const [output, setOutput] = useState({});
  const { fetchSpots } = useFetchGraphQL();


  useEffect(() => {
    if (!currentBooking.Date) return;

    const handleLoadingTimeout = () => {
      const elapsedTime = Date.now() - startTimeLoading;
      const remainingTime = Math.max(globalLoadingTime - elapsedTime, 0);
      setTimeout(() => setLoading(false), remainingTime);
    };

    setLoading(true);
    const startTimeLoading = Date.now();
    fetchSpots(currentBooking.Date)
    .then((response) => { 
      setExistingBookings(JSON.parse(JSON.stringify(response.data.data.spots.items)));
      handleLoadingTimeout();
    })
    .catch(() => {       
      handleLoadingTimeout();
    });
  }, [currentBooking.Date, refreshTimeSlots]);

  useEffect(() => {
    const generateOutput = () => {
      const output = {};
      
      resourceIds.forEach((resourceId) => {
        const isDesk = resourceId.startsWith("D");
        const relevantTimeSlots = isDesk ? currentBooking.TimeSlots : currentBooking.CabinTimeSlots;

        const hasMatchingTimeSlot = !existingBookings.some(
          (item) => item.ResourceId === resourceId && relevantTimeSlots.includes(item.Time)
        );
        output[resourceId] = hasMatchingTimeSlot;
      });

      setOutput(output);
      onOutputChange(output);
    };

    generateOutput();
  }, [existingBookings, currentBooking, onOutputChange]);

};

export default CheckTimeSlots;
